import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/brim/Nav";
import Hero from "@/components/brim/Hero";
import Marquee from "@/components/brim/Marquee";
import Stats from "@/components/brim/Stats";
import Gallery from "@/components/brim/Gallery";
import HowItWorks from "@/components/brim/HowItWorks";
import AgentDemo from "@/components/brim/AgentDemo";
import Checklist from "@/components/brim/Checklist";
import RoiCalculator from "@/components/brim/RoiCalculator";
import Faq from "@/components/brim/Faq";
import InterestForm from "@/components/brim/InterestForm";
import Footer from "@/components/brim/Footer";

const Landing = () => (
  <div className="grain font-sans-body bg-[#FAF8F5] text-[#1C1917] antialiased selection:bg-[#E7E5E4]">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Stats />
      <Gallery />
      <HowItWorks />
      <AgentDemo />
      <Checklist />
      <RoiCalculator />
      <Faq />
      <InterestForm />
    </main>
    <Footer />
    <Toaster position="bottom-center" />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
